var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionYay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1360_13260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2321 45.4642C35.5106 45.4642 45.4642 35.5106 45.4642 23.2321C45.4642 10.9536 35.5106 1 23.2321 1C10.9536 1 1 10.9536 1 23.2321C1 35.5106 10.9536 45.4642 23.2321 45.4642Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3379 22.1059C35.3379 29.0561 29.7036 34.6904 22.7533 34.6904C15.8031 34.6904 10.1688 29.0561 10.1688 22.1059C10.1688 15.1556 15.8031 9.52129 22.7533 9.52129C29.7036 9.52129 35.3379 15.1556 35.3379 22.1059Z",
    fill: "#EAE5F3",
    stroke: "#D3CAE9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1562 18.26C18.9705 17.5668 18.2579 17.1554 17.5647 17.3411C16.8714 17.5269 16.46 18.2395 16.6458 18.9327L16.1383 19.0687C15.8774 18.0952 16.4551 17.0945 17.4287 16.8337C18.4022 16.5728 19.4029 17.1505 19.6637 18.1241L19.1562 18.26Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2874 16.7783C27.1505 16.0737 26.4684 15.6136 25.7638 15.7506C25.0593 15.8875 24.5992 16.5697 24.7362 17.2742L24.2204 17.3744C24.0281 16.3851 24.6742 15.4271 25.6636 15.2348C26.6529 15.0425 27.6109 15.6886 27.8032 16.678L27.2874 16.7783Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1643 23.8185C19.6018 23.9065 21.5381 23.7329 23.628 23.2704C25.718 22.8079 27.5467 22.1484 28.8129 21.4621C29.4477 21.1181 29.9274 20.7746 30.2287 20.4561C30.5376 20.1297 30.6124 19.882 30.5744 19.7102L31.0874 19.5967C31.1829 20.0283 30.9579 20.4499 30.6103 20.8173C30.2552 21.1925 29.7218 21.5671 29.0633 21.924C27.7431 22.6396 25.8653 23.3134 23.7416 23.7834C21.6178 24.2533 19.631 24.4347 18.1322 24.3429C17.3846 24.2971 16.7429 24.1825 16.2626 23.9921C15.7925 23.8057 15.4107 23.5184 15.3152 23.0868L15.8282 22.9733C15.8662 23.1451 16.0385 23.3381 16.4563 23.5037C16.8638 23.6653 17.4437 23.7743 18.1643 23.8185Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1643 23.8185C19.6018 23.9065 21.5381 23.7329 23.628 23.2704C25.718 22.8079 27.5467 22.1484 28.8129 21.4621C29.4477 21.1181 29.9274 20.7746 30.2287 20.4561C30.5376 20.1297 30.6124 19.882 30.5744 19.7102L31.0874 19.5967C31.1829 20.0283 30.9579 20.4499 30.6103 20.8173C30.2552 21.1925 29.7218 21.5671 29.0633 21.924C27.7431 22.6396 25.8653 23.3134 23.7416 23.7834C21.6178 24.2533 19.631 24.4347 18.1322 24.3429C17.3846 24.2971 16.7429 24.1825 16.2626 23.9921C15.7925 23.8057 15.4107 23.5184 15.3152 23.0868L15.8282 22.9733C15.8662 23.1451 16.0385 23.3381 16.4563 23.5037C16.8638 23.6653 17.4437 23.7743 18.1643 23.8185Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1360_13260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionYay);
export default __webpack_public_path__ + "static/media/reaction_yay.ae3ccffd57373a6e1afcbc025379e412.svg";
export { ForwardRef as ReactComponent };